module.exports = __webpack_public_path__ + "images/aristo/progress_bar.gif";